import styled from "styled-components";

import { StyledBlueBackground } from "@/styles/components";

export const StyledTodoPanel = styled(StyledBlueBackground)`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
